/**
 * Hook de datos del **listado paginado de órdenes** (`GET /api/v1/orders`).
 *
 * Datos de servidor -> TanStack Query (`docs/frontend_conventions.md`, Datos): no
 * se usa `useState`+`useEffect`+`fetch` a mano. La query key incluye la sede
 * activa y los filtros (estado/búsqueda/página) para cachear por combinación. La
 * red la gobierna `lib/api` (cookie httpOnly + `X-Sede-Id`).
 *
 * `placeholderData: keepPreviousData` evita el parpadeo a vacío al paginar o
 * buscar: la tabla mantiene la página anterior mientras llega la nueva.
 */
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { getActiveSedeId } from "@/lib/sede";

import { fetchOrders } from "../api";
import type { OrdersPage, OrdersQuery } from "../types";
import { ordersListQueryKey } from "./queryKeys";

export function useOrders(query: OrdersQuery) {
  const sedeId = getActiveSedeId();
  return useQuery<OrdersPage>({
    queryKey: ordersListQueryKey(sedeId, query),
    queryFn: () => fetchOrders(query),
    placeholderData: keepPreviousData,
    // Margen corto: el listado puede cambiar a menudo (altas/transiciones), pero
    // evitamos refetch agresivo en cada foco sin volverlo rancio indefinidamente.
    staleTime: 15_000,
  });
}
